import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { useCallback } from 'react';
import '@dynamic-labs/sdk-api';
import '../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/multi-wallet';
import '../../context/ViewContext/ViewContext.js';
import '../../utils/constants/colors.js';
import { useOnClickOutside } from '../../shared/utils/hooks/useOnClickOutside/index.js';
import '../../shared/consts/index.js';
import { useInternalDynamicContext } from '../../context/DynamicContext/useInternalDynamicContext.js';
import { ShadowDOM } from '../../components/ShadowDOM/ShadowDOM.js';
import '../../context/ThemeContext/ThemeContext.js';
import 'react-dom';
import 'react-focus-lock';
import '../../components/Transition/ZoomTransition/ZoomTransition.js';
import '../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../components/Transition/OpacityTransition/OpacityTransition.js';
import '../../config/ApiEndpoint.js';
import '../../context/ErrorContext/ErrorContext.js';
import 'ethers';
import '../../context/MockContext/MockContext.js';
import '../../context/CaptchaContext/CaptchaContext.js';
import '../../utils/hooks/useUserUpdateRequest/useUserUpdateRequest.js';
import { DynamicConnectButton } from '../../components/DynamicConnectButton/DynamicConnectButton.js';
import '../../components/IconButton/IconButton.js';
import { IsBrowser } from '../../components/IsBrowser/IsBrowser.js';
import { DynamicNav } from './components/DynamicNav/DynamicNav.js';
import { DynamicUserProfile } from './components/DynamicUserProfile/DynamicUserProfile.js';
import { useWidgetContext } from './context/DynamicWidgetContext.js';

const DynamicWidget = ({ buttonContainerClassName = '', buttonClassName = '', innerButtonComponent = 'Connect your wallet', variant = 'modal', }) => {
    const { primaryWallet, user, showAuthFlow, setShowDynamicUserProfile } = useInternalDynamicContext();
    const { widgetRef, inlineControlsRef } = useWidgetContext();
    const closeOnOutsideClick = useCallback((e) => {
        var _a;
        const target = e.composedPath().shift();
        if ((_a = inlineControlsRef.current) === null || _a === void 0 ? void 0 : _a.contains(target))
            return;
        if (variant === 'dropdown' && !showAuthFlow) {
            setShowDynamicUserProfile(false);
        }
    }, [inlineControlsRef, variant, showAuthFlow, setShowDynamicUserProfile]);
    useOnClickOutside(widgetRef, closeOnOutsideClick);
    return (jsx(IsBrowser, { children: jsx(ShadowDOM, Object.assign({ className: 'dynamic-widget__container', id: 'dynamic-widget' }, { children: !primaryWallet && !user ? (jsx(DynamicConnectButton, Object.assign({ buttonContainerClassName: buttonContainerClassName, buttonClassName: buttonClassName }, { children: innerButtonComponent }))) : (jsxs(Fragment, { children: [jsx(DynamicNav, {}), jsx(DynamicUserProfile, { variant: variant })] })) })) }));
};

export { DynamicWidget };
